import React from "react";
import AdminCard from "./adminCard";
import "./readytopick.css";

const ReadyToPick = ({
  ordersFound,
  data,
  handleStatusClick,
  handleDeliveryClick,
  handleChef,
  handleChefPenality,
  handleBookDaas,
  handleCancelDaas,
  handleComment,
  handleRefund
}) => {
  const handleOrder = (orderID) => {
    window.open(`/order?orderID=${orderID}`, "_blank");
  };

  return (
    <div className="readytopick">
      {ordersFound ? (
        data.map((data, id) => (
          <AdminCard
            id={id}
            data={data}
            handleOrder={handleOrder}
            handleChef={handleChef}
            status="READY TO PICK"
            handleStatusClick={handleStatusClick}
            handleDeliveryClick={handleDeliveryClick}
            handleChefPenality={handleChefPenality}
            handleBookDaas={handleBookDaas}
            handleCancelDaas={handleCancelDaas}
            handleComment={handleComment}
            handleRefund={handleRefund}
          />
        ))
      ) : (
        <h1>No Ready To Pick Orders</h1>
      )}
    </div>
  );
};

export default ReadyToPick;
